export const DROP_SUCCESS = 'DROP_SUCCESS';
export const GET_ALL_DRAG = 'GET_ALL_DRAG';
export const ADD_DRAG_ELEMENT = 'ADD_DRAG_ELEMENT';

export const getAllDrag = () => {
    return {
        type: GET_ALL_DRAG
    }
}

export const addDragEmelements = (data, element) => {
    return {
        type: ADD_DRAG_ELEMENT,
        data: data
    }
}


// WEBPACK FOOTER //
// ./src/Services/Drag/action.js